import * as types from '../mutation-types'
export default {
	namespaced: true,

	state: {
		vacations: []
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/vacation').then(({ data }) => {
				commit(types.STORE_VACATION, data);
				return data;
			})
		}
	},

	mutations: {
		[types.STORE_VACATION](state, vacations) {
			state.vacations = vacations;
		}
	}
}